import React, { memo } from 'react';
import { Button, DialogBody, DialogContainer, DialogFooter, DialogHeader } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';

import PatrolsBundlesList from '~/pages/Patrols/containers/PatrolsBundlesList/PatrolsBundlesList';

import styles from './PatrolsRewardsListDialog.module.scss';

import type { IDialog } from '~/types/declaration';

type IPatrolsRewardsListDialog = IDialog<{
  title?: string;
}>;

const PatrolsRewardsListDialog: React.FC<IPatrolsRewardsListDialog> = ({ hideDialog }) => {
  return (
    <DialogContainer className={styles.container}>
      <DialogHeader>{t('all rewards')}</DialogHeader>
      <DialogBody adaptiveHeight>
        <PatrolsBundlesList isDisabledAnimations />
      </DialogBody>
      <DialogFooter>
        <Button isFlat onClick={hideDialog}>
          {t('Закрыть')}
        </Button>
      </DialogFooter>
    </DialogContainer>
  );
};

export default memo(PatrolsRewardsListDialog);
